<template>
   <div class="card mb-0" ref="sentenciado" :class="sentenciado.status == 'DESCUMPRIMENTO' || sentenciado.status == 'Descumprimento' ? 'border-danger' : ''">
      <div class="card-body">
         <div class="d-flex align-items-center">
            <div class="flex-grow-1">
               <h5 class="mb-1 limitador font-18" :title="sentenciado.nomeCompleto">{{sentenciado.nomeCompleto}}</h5>
               <p class="text-muted mb-0 limitador" :title="sentenciado.nomeEntidade">{{sentenciado.nomeEntidade}}</p>
            </div>
         </div>
         
         <hr class="my-3">
         
         <div class="row g-3">
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">{{sentenciado.tipoDocumento || 'Documento'}}</small>
                     <span class="limitador">{{sentenciado.identificacao || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">Processo</small>
                     <span class="limitador">{{sentenciado.numeroProcesso || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6 mb-2">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">Status</small>
                     <span class="limitador" :class="sentenciado.status == 'DESCUMPRIMENTO' || sentenciado.status == 'Descumprimento' ? 'text-danger' : ''">{{(sentenciado.status ? sentenciado.status.charAt(0).toUpperCase() + sentenciado.status.slice(1).toLowerCase() : 'Não informado')}}</span>
                  </div>
               </div>
            </div>
            <div class="col-md-6">
               <div class="d-flex align-items-center">
                  <div>
                     <small class="text-muted d-block">Sexo</small>
                     <span class="limitador">{{sentenciado.sexo || 'Não informado'}}</span>
                  </div>
               </div>
            </div>
         </div>

         <div class="progress mt-3" style="height: 15px">
            <div class="progress-bar bg-success font-12" 
                  :style="{width: (sentenciado.horasCumpridas/sentenciado.totalHoras*100) + '%', transition: 'width 0.5s ease'}"
                  :title="formatarMinutosParaHoras(sentenciado.horasCumpridas) + ' cumpridas'">
               {{sentenciado.horasCumpridas/sentenciado.totalHoras*100 >= 25 ? formatarMinutosParaHoras(sentenciado.horasCumpridas) : formatarMinutosParaHoras(sentenciado.horasCumpridas)}} h
            </div>
            <div class="progress-bar bg-warning font-12" 
                  :style="{width: (sentenciado.horasPendentes/sentenciado.totalHoras*100) + '%', transition: 'width 0.5s ease'}"
                  :title="formatarMinutosParaHoras(sentenciado.horasPendentes) + ' pendentes'">
               {{sentenciado.horasCumpridas/sentenciado.totalHoras*100 >= 75 ? formatarMinutosParaHoras(sentenciado.horasPendentes) : formatarMinutosParaHoras(sentenciado.horasPendentes)}} h
            </div>
         </div>
         <div class="d-flex justify-content-between mt-2">
            <small class="text-muted">Total: {{formatarMinutosParaHoras(sentenciado.totalHoras)}} h</small>
            <small class="text-success">{{Math.round(sentenciado.horasCumpridas/sentenciado.totalHoras*100)}}% concluído</small>
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
	name: 'Sentenciado',
   props: ['sentenciado', 'index'],
   computed: {
      ... mapState({
         tokenSessao: state => state.tokenSessao,
         urlRest: state => state.urlRest
      })
   },
   methods: {
      formatarMinutosParaHoras(minutos) {
         const horas = Math.floor(minutos / 60);
         const minutosRestantes = minutos % 60;
         return `${String(horas).padStart(2, '0')}:${String(minutosRestantes).padStart(2, '0')}`;
      },
      editar() {
         this.$emit('editar', this.sentenciado)
      },
      imprimir() {
         this.$emit('imprimir', this.sentenciado.id)
      },
      excluir() {
         this.$emit('excluir', this.sentenciado)
      },
   }
}

</script>
<style scoped>

.bg-success {
   background-color: var(--primary-color) !important;
}

.bg-warning {
   background-color: #7979794f !important;
}

.border-danger {
   border: 1px #D23443 solid !important;
}

</style>